export default __webpack_public_path__ + "static/media/empty-helper.ce87af7b.svg";